const MAIN_URL = "https://api.3rgroup.lk:9999";

export const constants = {
  main_url: MAIN_URL
};
